import React, {useEffect, useState} from 'react';
import {motion} from "motion/react"
import './Typing.css';

const Typing = ({
                    text = '',
                    secondaryText = undefined,
                    delay = 0,
                    speed = 50,
                    timeout = null,
                    onComplete = null,
                    className = '',
                    style = {},
                    type = "letter" // "letter" | "word"
                }) => {
    const [displayedText, setDisplayedText] = useState('');
    const displayedRef = React.useRef('');
    const [isVisible, setIsVisible] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [hasStarted, setHasStarted] = useState(false);
    const [isCompleted, setIsCompleted] = useState(false);

    // Dividir texto según el tipo
    const units = type === "word" ? text.split(" ") : text.split("");
    const separator = type === "word" ? " " : "";

    // Manejar el delay inicial
    useEffect(() => {
        if (delay > 0) {
            const delayTimer = setTimeout(() => {
                setHasStarted(true);
            }, delay);

            return () => clearTimeout(delayTimer);
        } else {
            setHasStarted(true);
        }
    }, [delay]);

    // Manejar el efecto de typing
    useEffect(() => {
        if (!hasStarted || !text) return;

        if (currentIndex < units.length && !isCompleted) {
            const timer = setTimeout(() => {
                displayedRef.current += (currentIndex > 0 ? separator : "") + units[currentIndex];
                setDisplayedText(displayedRef.current);
                setCurrentIndex(prev => prev + 1);
            }, speed);

            return () => clearTimeout(timer);
        } else {
            // Texto completado
            if (onComplete) {
                onComplete();
            }
            setIsCompleted(true);

            // Manejo del secondaryText
            if (secondaryText) {
                const removeTimer = setTimeout(() => {
                    if (displayedRef.current !== secondaryText) {
                        displayedRef.current = displayedRef.current.slice(0, -1);
                        setDisplayedText(displayedRef.current);
                        setCurrentIndex(prev => prev - 1);
                    } else {
                        setIsCompleted(false);
                    }
                }, speed);
                return () => clearTimeout(removeTimer);
            }
        }
    }, [currentIndex, units, speed, hasStarted, onComplete, isCompleted, text, separator, secondaryText]);

    // Manejar el timeout para desaparecer
    useEffect(() => {
        if (timeout && currentIndex >= units.length && units.length > 0) {
            const timeoutTimer = setTimeout(() => {
                setIsVisible(false);
            }, timeout);

            return () => clearTimeout(timeoutTimer);
        }
    }, [timeout, currentIndex, units.length]);

    // Reset cuando cambia el texto
    useEffect(() => {
        setDisplayedText('');
        setCurrentIndex(0);
        setIsVisible(true);
        setHasStarted(delay === 0);
        displayedRef.current = '';
    }, [text, delay, type]);

    if (!hasStarted) {
        return null;
    }

    return (
        <motion.div
            className={`typing-component ${className}`}
            style={style}
            initial={{opacity: 1}}
            animate={{opacity: isVisible ? 1 : 0}}
            transition={{duration: timeout ? timeout / 1000 : 0.3}}
        >
            <span className="typing-text">
                {displayedText}
                {currentIndex < units.length && (
                    <motion.span
                        className="typing-cursor"
                        animate={{opacity: [1, 0]}}
                        transition={{
                            duration: 0.8,
                            repeat: Infinity,
                            repeatType: "reverse"
                        }}
                    >
                        |
                    </motion.span>
                )}
            </span>
        </motion.div>
    );
};

export default Typing;
